<template>
  <div
    class="page--ridecredit"
    :style="`min-height: ${height}px`"
  >
    <Header :kind="routeParams.type" :status="currentStatus" />

    <Form
      :kind="routeParams.type"
      :submit="submitForm"
      :data="creditData"
      :status="currentStatus"
      @tryAgain="getCreditById"
      @setCurrentStatus="setCurrentStatus"
    />

    <Footer
      :kind="routeParams.type"
      :status="currentStatus"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { mapActions } from 'vuex'
import Header from 'components/rideCredit/Header'
import Form from 'components/rideCredit/Form'
import Footer from 'components/rideCredit/Footer'

export default {
  name: 'RideCreditPage',
  components: {
    Header,
    Form,
    Footer
  },
  computed: {
    routeParams () {
      return this.$route.params
    },

    height () {
      return document.body.offsetHeight
    }
  },
  data () {
    return {
      namespace: 'Views.RideCreditPage',
      submitForm: false,
      creditData: null,
      currentStatus: null
    }
  },
  methods: {
    ...mapActions({
      errorAlert: 'snackbarAlert/error',
      showAlert: 'snackbar/show'
    }),

    handleSubmit () {
      this.submitForm = !this.submitForm
    },

    setCurrentStatus (val) {
      if (val) this.currentStatus = val
    },

    setChatPosition (bottom = null, right = null) {
      const chat = document.querySelector('#oloswcdl-root .oloswebchat-main .cta-button')
      if (chat) {
        chat.style.bottom = bottom
        chat.style.right = right
      }
    },

    async getCreditById () {
      // TO DO
      // await this.$apiService.cancelCredit('5e8f7dae42a73100018996df')

      if (this.routeParams.type === 'editar') {
        this.currentStatus = STATUS_IS_LOADING

        try {
          const apiTaxiJobId = Number(this.routeParams.id)
          const { data: creditResponse } = await this.$apiService.getCreditById(apiTaxiJobId)
          const { data: receiptResponse } = await this.$apiService.searchApiTaxiJobId(apiTaxiJobId)

          if (
            (!creditResponse || (creditResponse && !creditResponse.valid)) &&
            (!receiptResponse || (receiptResponse && !receiptResponse.valid))
          ) {
            this.currentStatus = STATUS_FAILED
          }

          if (
            (creditResponse && !creditResponse.content) &&
            (receiptResponse && !receiptResponse.content)
          ) {
            this.$router.push({
              name: 'FinancialAdjustments',
              query: { tab: 2 }
            })

            this.showAlert({
              type: 'info',
              message: this.$t(`${this.namespace}.creditNotFound`)
            })

            this.currentStatus = STATUS_FAILED
          }

          this.creditData = {
            credit: { ...creditResponse.content },
            receipt: { ...receiptResponse.content }
          }

          this.currentStatus = STATUS_SUCCESS
        } catch (err) {
          console.log('ERROR', err)
          this.currentStatus = STATUS_FAILED
          this.showAlert({
            type: 'error',
            message: this.$t(`${this.namespace}.creditError`)
          })
        }
      }
    }
  },
  watch: {
    'routeParams.id' () {
      location.reload()
    }
  },
  beforeMount () {
    if (
      this.routeParams.type !== 'cadastrar' &&
      this.routeParams.type !== 'editar'
    ) {
      this.$router.push({
        name: 'FinancialAdjustments',
        query: { tab: 2 }
      })
    }
  },
  mounted () {
    this.getCreditById()

    if (this.routeParams.type !== 'editar') {
      this.currentStatus = STATUS_SUCCESS
    }

    this.setChatPosition('75px', '10px')
  },
  beforeDestroy () {
    this.setChatPosition()
  }
}
</script>
